'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EditorViewStore = exports.ActionBar = undefined;

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _class, _dec, _dec2, _dec3, _desc, _value, _class2, _descriptor, _class4, _class5, _temp2;

exports.createEditorElement = createEditorElement;
exports.propperCase = propperCase;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

require('trix');

require('trix/dist/trix.css');

var _reactTrix = require('react-trix');

var _mobx = require('mobx');

var _mobxReact = require('mobx-react');

var _baseComponent = require('base-component');

var _baseComponent2 = _interopRequireDefault(_baseComponent);

var _baseViewstore = require('base-viewstore');

var _baseViewstore2 = _interopRequireDefault(_baseViewstore);

var _baseContentmodel = require('base-contentmodel');

var _baseContentmodel2 = _interopRequireDefault(_baseContentmodel);

var _mixwith = require('mixwith');

var _layoutComponent = require('layout-component');

var _decorator = require('./decorator');

var _decorator2 = _interopRequireDefault(_decorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

function createEditorElement(k, slots, contentModel, viewStore, initParams) {
  if ((!initParams || !initParams.insideEditor) && viewStore && viewStore.props.insideEditor) {
    initParams = initParams || {};
    initParams.insideEditor = true;
  }
  var ret = void 0;
  var propIsReadOnly = contentModel.readonly || contentModel.meta && contentModel.meta[k] && contentModel.meta[k].readonly;
  var slot = slots[k];
  var options = contentModel._options && contentModel._options[k];
  if (k === "id") {
    ret = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: 'editor-label' },
        'Id: '
      ),
      contentModel.isNew ? _react2.default.createElement('input', { onChange: function onChange(e) {
          return contentModel.updateValue("id", e.target.value);
        }, value: contentModel.id }) : contentModel.id
    );
  } else if (Array.isArray(slot)) {
    //if( slot.length > 1 ) throw new Error("multiple content model types per slot not yet supported")
    var args = initParams ? [contentModel, k, initParams] : [contentModel, k];
    ret = !contentModel.isNew ? _react2.default.createElement(
      'div',
      { 'data-editable': args },
      _react2.default.createElement(
        'span',
        { className: 'editor-label' },
        propperCase(k),
        ':'
      ),
      contentModel[k].map(function (cm) {
        return _react2.default.createElement(
          'div',
          { key: cm.id },
          _react2.default.createElement(
            'span',
            { className: 'editable-item', onClick: function onClick(e) {
                return cm.editable !== false && viewStore.viewItem(cm, initParams);
              } },
            cm.uniqueDisplayName
          )
        );
      }),
      _react2.default.createElement('br', null)
    ) : _react2.default.createElement(
      'div',
      null,
      propperCase(k),
      ': [ ]'
    );
  } else if (slot && slot.prototype && slot.prototype instanceof _baseContentmodel2.default || slot === _baseContentmodel2.default) {
    var _args = initParams ? [contentModel, k, initParams] : [contentModel, k];
    ret = _react2.default.createElement(
      'div',
      { 'data-editable': _args },
      _react2.default.createElement(
        'span',
        { className: 'editor-label' },
        propperCase(k),
        ':'
      ),
      !!contentModel[k] && _react2.default.createElement(
        'span',
        { className: 'editable-item', onClick: function onClick(e) {
            return contentModel[k].editable !== false && viewStore.viewItem(contentModel[k], initParams);
          } },
        contentModel[k].uniqueDisplayName
      )
    );
  } else if (slot == null || (typeof slot === 'undefined' ? 'undefined' : (0, _typeof3.default)(slot)) === "object") {
    console.warn("basic objects not yet supported");
    //simple object
  } else if (typeof slot === "string") {
    if (slot === "Array") {
      ret = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 'editor-label' },
          propperCase(k),
          ':'
        ),
        contentModel[k].map(function (str, i) {
          return _react2.default.createElement(
            'div',
            { key: str.replace(/ /g, "").substring(0, 20) + i },
            _react2.default.createElement(
              'span',
              null,
              str
            ),
            ' - ',
            _react2.default.createElement(
              'span',
              { onClick: function onClick() {
                  return contentModel[k].splice(i, 1);
                } },
              'x'
            )
          );
        }),
        _react2.default.createElement('textarea', null),
        _react2.default.createElement(
          'button',
          { onClick: function onClick(e) {
              return e.target.previousSibling.value && contentModel[k].push(e.target.previousSibling.value) && (e.target.previousSibling.value = "");
            } },
          'Add'
        )
      );
    } else if (slot === "RichText" && viewStore && viewStore.swapRichTextToHtml !== true) {
      ret = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 'editor-label' },
          propperCase(k),
          ':'
        ),
        viewStore && _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement('input', {
            type: 'checkbox',
            checked: viewStore.swapRichTextToHtml,
            onChange: function onChange(e) {
              return viewStore.swapRichTextToHtml = true;
            } }),
          ' Swap To HTML'
        ),
        _react2.default.createElement(_reactTrix.TrixEditor, { disabled: propIsReadOnly, id: "trix-" + k, type: 'hidden', name: 'content', value: contentModel[k],
          onChange: function onChange(value) {
            return contentModel.updateValue(k, value);
          } })
      );
    } else if (Array.isArray(options)) {
      ret = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 'editor-label' },
          propperCase(k),
          ':'
        ),
        _react2.default.createElement(
          'select',
          { disabled: propIsReadOnly, value: contentModel[k], onChange: function onChange(e) {
              return contentModel.updateValue(k, e.target.value);
            } },
          _react2.default.createElement('option', null),
          options.map(function (o) {
            return _react2.default.createElement(
              'option',
              { key: o },
              o
            );
          })
        )
      );
    } else {
      //simple string
      ret = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'span',
          { className: 'editor-label' },
          propperCase(k),
          ': '
        ),
        slot === "RichText" && viewStore && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement('input', {
            type: 'checkbox',
            checked: viewStore.swapRichTextToHtml,
            onChange: function onChange(e) {
              return viewStore.swapRichTextToHtml = false;
            } }),
          _react2.default.createElement(
            'span',
            null,
            'Swap To RichText'
          )
        ),
        _react2.default.createElement('textarea', {
          disabled: propIsReadOnly,
          value: contentModel[k],
          onChange: function onChange(e) {
            return contentModel.updateValue(k, e.target.value);
          }
        }),
        k === "imageUrl" && _react2.default.createElement('img', { src: contentModel[k] })
      );
    }
  } else if (typeof slot === "number") {
    //simple number
    ret = _react2.default.createElement(
      'div',
      null,
      k,
      ': ',
      _react2.default.createElement('input', {
        disabled: propIsReadOnly,
        value: contentModel[k],
        onChange: function onChange(e) {
          return contentModel.updateValue(k, +e.target.value);
        }
      })
    );
  } else if (typeof slot === "boolean") {
    ret = _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'span',
        { className: 'editor-label' },
        k,
        ':'
      ),
      _react2.default.createElement('input', { id: k,
        disabled: propIsReadOnly,
        type: 'checkbox',
        checked: contentModel[k],
        onChange: function onChange(e) {
          return contentModel.updateValue(k, e.target.checked);
        }
      }),
      _react2.default.createElement(
        'label',
        null,
        _react2.default.createElement('span', null)
      )
    );
  }

  return _react2.default.createElement(
    'div',
    { className: 'editable-group' },
    contentModel.invalid && contentModel.invalid[k] && _react2.default.createElement(
      'span',
      { className: "validation-error errorMsg " + k },
      contentModel.invalid[k]
    ),
    !!ret && ret
  );
}

/* Proper case a camel case property name */
function propperCase(propertyName) {
  return propertyName.replace(/([A-Z])/g, ' $1').replace(/^./, function (str) {
    return str.toUpperCase();
  });
}

var ActionBar = exports.ActionBar = (0, _mobxReact.observer)(_class = function (_BaseComponent) {
  (0, _inherits3.default)(ActionBar, _BaseComponent);

  function ActionBar() {
    (0, _classCallCheck3.default)(this, ActionBar);
    return (0, _possibleConstructorReturn3.default)(this, (ActionBar.__proto__ || (0, _getPrototypeOf2.default)(ActionBar)).apply(this, arguments));
  }

  (0, _createClass3.default)(ActionBar, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          contentModel = _props.contentModel,
          onSave = _props.onSave;

      return _react2.default.createElement(
        'div',
        { className: 'editable-group' },
        _react2.default.createElement(
          'button',
          { className: 'btn green upload-b', key: 'save', disabled: !contentModel.allowSave, onClick: function onClick(e) {
              return onSave ? contentModel.saveEntity(function () {
                return onSave(contentModel);
              }) : contentModel.saveEntity();
            } },
          'Save'
        ),
        _react2.default.createElement(
          'button',
          { className: 'btn red cancel-b', key: 'revert', disabled: !contentModel.isDirty, onClick: function onClick(e) {
              return contentModel.revert();
            } },
          'Cancel'
        ),
        contentModel.invalid.hasBrokenRefs && _react2.default.createElement(
          'div',
          null,
          contentModel.invalid.hasBrokenRefs
        )
      );
    }
  }]);
  return ActionBar;
}(_baseComponent2.default)) || _class;

var EditorViewStore = exports.EditorViewStore = (_dec = _mobx.action.bound, _dec2 = _mobx.action.bound, _dec3 = _mobx.action.bound, (_class2 = function (_mix$with) {
  (0, _inherits3.default)(EditorViewStore, _mix$with);

  function EditorViewStore() {
    var _ref;

    var _temp, _this2, _ret;

    (0, _classCallCheck3.default)(this, EditorViewStore);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = EditorViewStore.__proto__ || (0, _getPrototypeOf2.default)(EditorViewStore)).call.apply(_ref, [this].concat(args))), _this2), _initDefineProp(_this2, 'swapRichTextToHtml', _descriptor, _this2), _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(EditorViewStore, [{
    key: 'save',
    value: function save(e) {
      var contentModel = this.props.contentModel;
      var id = contentModel.id,
          error = contentModel.error,
          isNew = contentModel.isNew,
          invalid = contentModel.invalid,
          readonly = contentModel.readonly;
      var primaryOptions = this.options;
      var secondaryOptions = this.props.options;

      var options = (0, _extends3.default)({}, secondaryOptions, primaryOptions);

      if (!contentModel) throw new Error("content model missing!");
      var onSave = options.onSave,
          onError = options.onError;

      contentModel.saveEntity(function () {
        return onSave && onSave(contentModel);
      }, onError);
    }
  }, {
    key: 'editItem',
    value: function editItem(item /*, opts = {}*/) {
      if (!(item instanceof _baseContentmodel2.default)) throw new Error("item must be a content model");
      var editorViewStore = this.props.editorViewStore;

      editorViewStore.startEditing(item);
    }
  }, {
    key: 'viewItem',
    value: function viewItem(item) {
      var _this3 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!(item instanceof _baseContentmodel2.default)) throw new Error("item must be a content model");
      if (this.lastCm && this.lastCm.length) {
        var lastCm = this.lastCm[0];
        if (lastCm && lastCm.isDirty) /*|| (this.contentModel && this.contentModel.isDirty)*/{
            lastCm.handleUnsavedChanges(function () {
              return _this3.selectView(item, opts);
            });
          } else {
          this.selectView(item, opts);
        }
      } else {
        this.selectView(item, opts);
      }
    }
  }, {
    key: 'viewMap',
    get: function get() {
      var contentModel = this.props.currentView && this.props.currentView.contentModel || this.props.contentModel;
      return contentModel && (0, _keys2.default)(contentModel.slots).reduce(function (acc, name) {
        if (contentModel.slots[name] && contentModel.slots[name].prototype instanceof _baseContentmodel2.default) {
          var cmType = contentModel.slots[name];
          acc[cmType.name] = {
            id: cmType.name,
            ContentModelType: cmType
          };
        } else if (Array.isArray(contentModel.slots[name])) {
          var _cmType = contentModel.slots[name][0];
          acc[_cmType.name] = {
            id: _cmType.name,
            ContentModelType: _cmType
          };
          if (contentModel.slots[name].length > 1) {
            acc[_cmType.name].ids = [];
            acc[_cmType.name].ContentModelTypes = [];
            for (var i in contentModel.slots[name]) {
              acc[_cmType.name].ids.push(contentModel.slots[name][i].name);
              acc[_cmType.name].ContentModelTypes.push(contentModel.slots[name][i]);
            }
          }
        }
        return acc;
      }, {});
    }
  }]);
  return EditorViewStore;
}((0, _mixwith.mix)(_baseViewstore2.default).with(_layoutComponent.ViewControllerMixin)), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, 'swapRichTextToHtml', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _applyDecoratedDescriptor(_class2.prototype, 'save', [_dec], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'save'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'editItem', [_dec2], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'editItem'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'viewItem', [_dec3], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'viewItem'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'viewMap', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'viewMap'), _class2.prototype)), _class2));

var DefaultEditor = (0, _decorator2.default)(_class4 = (0, _mobxReact.observer)(_class4 = (_temp2 = _class5 = function (_BaseComponent2) {
  (0, _inherits3.default)(DefaultEditor, _BaseComponent2);

  function DefaultEditor() {
    (0, _classCallCheck3.default)(this, DefaultEditor);
    return (0, _possibleConstructorReturn3.default)(this, (DefaultEditor.__proto__ || (0, _getPrototypeOf2.default)(DefaultEditor)).apply(this, arguments));
  }

  (0, _createClass3.default)(DefaultEditor, [{
    key: 'render',
    value: function render() {
      var viewStore = this.viewStore,
          _viewStore = this.viewStore,
          save = _viewStore.save,
          currentView = _viewStore.currentView,
          isRoot = _viewStore.isRoot,
          viewBreadcrumbs = _viewStore.viewBreadcrumbs,
          SelectedView = _viewStore.SelectedView;
      var _props2 = this.props,
          contentModel = _props2.contentModel,
          editorViewStore = _props2.editorViewStore,
          passDownToLeaf = _props2.passDownToLeaf,
          options = _props2.options,
          showButtons = _props2.showButtons,
          children = _props2.children;
      var id = contentModel.id,
          error = contentModel.error,
          isNew = contentModel.isNew,
          invalid = contentModel.invalid,
          readonly = contentModel.readonly,
          EditorAppend = contentModel.EditorAppend;
      // !editorViewStore;
      // const options = primaryOptions || secondaryOptions;

      var hideProps = options && options.hideProps || [];
      var onlyShow = options && options.onlyShow || [];

      return _react2.default.createElement(
        'div',
        null,
        isRoot && _react2.default.createElement(_layoutComponent.Breadcrumbs, { viewstores: viewBreadcrumbs }),
        !currentView ? _react2.default.createElement(
          'div',
          null,
          isNew && _react2.default.createElement(
            'div',
            { className: 'editor-id' },
            createEditorElement("id", contentModel.slots, contentModel)
          ),
          (0, _keys2.default)(contentModel.slots).filter(function (k) {
            return options && (!onlyShow.length || onlyShow.indexOf(k) > -1) && hideProps.indexOf(k) === -1;
          }).map(function (k) {
            return _react2.default.createElement(
              'div',
              { key: k },
              createEditorElement(k, contentModel.slots, contentModel, viewStore, options)
            );
          }),
          showButtons !== false && _react2.default.createElement(ActionBar, { contentModel: contentModel, onSave: save }),
          !!children && children,
          !!EditorAppend && _react2.default.createElement(EditorAppend, { contentModel: contentModel })
        ) : //else IN DIRECT EDIT VIEW
        _react2.default.createElement(SelectedView, null)
      );
    }
  }]);
  return DefaultEditor;
}(_baseComponent2.default), _class5.ViewStore = EditorViewStore, _temp2)) || _class4) || _class4;

// @TODO new content model that has submodels is a special case
// {invalid.children && invalid.children.length && (
//   <div className="errorMessage">These sub-models are invalid or unsaved: {invalid.children.map( (id,ind,arr) => id + ((ind !== arr.length-1) ? ", " : "") )}</div>
// )}


exports.default = DefaultEditor;
;

var _temp3 = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(createEditorElement, 'createEditorElement', 'src/core_modules/simbox-editable/editor.js');

  __REACT_HOT_LOADER__.register(propperCase, 'propperCase', 'src/core_modules/simbox-editable/editor.js');

  __REACT_HOT_LOADER__.register(ActionBar, 'ActionBar', 'src/core_modules/simbox-editable/editor.js');

  __REACT_HOT_LOADER__.register(EditorViewStore, 'EditorViewStore', 'src/core_modules/simbox-editable/editor.js');

  __REACT_HOT_LOADER__.register(DefaultEditor, 'DefaultEditor', 'src/core_modules/simbox-editable/editor.js');
}();

;


//////////////////
// WEBPACK FOOTER
// ./~/platform-client-bootstrap/dist/core_modules/simbox-editable/editor.js
// module id = ./node_modules/platform-client-bootstrap/dist/core_modules/simbox-editable/editor.js
// module chunks = 0